export const isString = value => {
  if (typeof value === 'string' || value instanceof String) {
    return value;
  } else
    return 'Oops, something went wrong. Please try again later or contact Webfuse support at support@webfuse.io.';
};
